import React from 'react'
import { saveAs } from 'file-saver'
import { useTranslation } from 'react-i18next'
import { ReactComponent as CSVIcon } from 'core/assets/images/documents/csvIcon.svg'
import { extractCSV } from 'core/utils/service'

export const DownloadResultButtons: React.FC<{
  message: string
  formats: string[] | null
}> = ({ message, formats }) => {
  if (!formats || formats.length === 0) return null
  const { t } = useTranslation()
  const handleDownload = (format: string) => {
    let content = ''
    let mimeType = 'text/plain'
    let extension = format.replace('.', '')

    switch (format) {
      case 'csv':
        const BOM = '\uFEFF'
        content = BOM + extractCSV(message)
        mimeType = 'text/csv'
        break
      default:
        content = message
        mimeType = 'text/plain'
    }

    const blob = new Blob([content], { type: mimeType })
    saveAs(blob, `result_${Date.now()}.${extension}`)
  }

  return (
    <div className="flex gap-2">
      {formats.map((format) => (
        <button
          key={format}
          onClick={() => handleDownload(format)}
          className="download-file-button"
        >
          <div className="bg-white-200 dark:bg-gray-1600 rounded-full p-2 flex items-center justify-center">
            <CSVIcon className="text-green-1250" />
          </div>
          <div className="underline">{t('prompts.form.downloadFile')}</div>
        </button>
      ))}
    </div>
  )
}
